import type { AllTrustedAdvisorsQuery } from '@/.generated/tbfTypes/graphql'
import { createContext } from 'react'

export const AllTrustedAdvisorsContext = createContext<
  AllTrustedAdvisorsQuery['trustedAdvisors'] | undefined
>(undefined)
